import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

// Компоненты админ панели
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import UsersManagement from './pages/UsersManagement';
import OrdersManagement from './pages/OrdersManagement';
import MenuManagement from './pages/MenuManagement';
import Analytics from './pages/Analytics';
import HourlyStatistics from './pages/HourlyStatistics';
import CategoryStats from './pages/CategoryStats';
import DishStats from './pages/DishStats';
import ShiftStats from './pages/ShiftStats';
import Settings from './pages/Settings';
import CashShifts from './pages/CashShifts';
import CurrentCash from './pages/CurrentCash';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
function AppInner() {
  return (
      <Routes>
        {/* Страница входа */}
        <Route path="/login" element={<Login />} />
        
        {/* Админ панель (корень поддоменного сайта) */}
        <Route path="/*" element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<UsersManagement />} />
          <Route path="orders" element={<OrdersManagement />} />
          <Route path="menu" element={<MenuManagement />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="reports/categories" element={<CategoryStats />} />
          <Route path="reports/dishes" element={<DishStats />} />
          <Route path="reports/shifts" element={<ShiftStats />} />
          <Route path="hourly-statistics" element={<HourlyStatistics />} />
          <Route path="cash-shifts" element={<CashShifts />} />
          <Route path="current-cash" element={<CurrentCash />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        
        {/* Перенаправления */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
  );
}

function App() {
  return <AppInner />;
}


export default App; 